


























import { Component, Vue, Prop } from 'nuxt-property-decorator'

@Component
export default class ComponentVideo extends Vue {
  @Prop({ type: String }) readonly item!: string
  @Prop({ type: String, default: 'rutube' }) readonly type!:
    | 'youtube'
    | 'rutube'
}
